"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BubbleSeries = void 0;
var __1 = require("../..");
var constants_1 = require("../../../scales/constants");
var constants_2 = require("../../../specs/constants");
var spec_factory_1 = require("../../../state/spec_factory");
var specs_1 = require("../utils/specs");
var defaultProps = {
    chartType: __1.ChartType.XYAxis,
    specType: constants_2.SpecType.Series,
    seriesType: specs_1.SeriesType.Bubble,
    groupId: specs_1.DEFAULT_GLOBAL_ID,
    xScaleType: constants_1.ScaleType.Ordinal,
    yScaleType: constants_1.ScaleType.Linear,
    xAccessor: 'x',
    yAccessors: ['y'],
    hideInLegend: false,
};
exports.BubbleSeries = (0, spec_factory_1.getConnect)()((0, spec_factory_1.specComponentFactory)(defaultProps));
//# sourceMappingURL=bubble_series.js.map